import { PlatformInviteStatus } from './enums/platformInviteStatus';
import { EntityTypes } from './enums/entityTypes';

export interface PlatformInvite {
  inviteId: string;
  inviteToken: string;
  entityType: EntityTypes.platformInvite;
  inviteEmail: string;
  orgId: string;
  status: PlatformInviteStatus;
  created: number;
  lastUpdated: number;
}

export interface CreatePlatformInviteProps {
  inviteEmail: string;
  orgId: string;
}

export interface AcceptPlatformInviteAPIProps { 
  inviteToken: string;
  firstName: string;
  lastName: string;
  email: string;
  title: string;
}